import Vue from 'vue'
// models component
import App from '@/models/App'
import ProfileAttend from '@/models/ProfileAttend'

export default class TokenVerify {
    // Token Verify
    static of() {
        return ProfileAttend.api()
            .verify()
            .then(function (result) {
                console.log('Token Verify', ProfileAttend.one())
                let token = ProfileAttend.one().token
                App.setLogined(true)
                App.setToken(token)
            })
            .catch((error) => {
                //Vue.$cookies.remove(key, path)
                return new Promise((resolve, reject) => {
                    reject(new Error())
                })
            })
    }
}
